import * as React from 'react'
import { Button, TextField } from '@material-ui/core'

import { MUIAdornment, MUIBlock, MUIBlockDivider, MUITooltip } from '../../MUI'
import { FormSettingsRow } from '../../MUI/Forms'
import { SvgIcon } from '../../../../components'
import { CertIcon } from '../CertIcon'

import { tl } from '../../../../utils'
import { useStyles } from './style'
import api from '../../../../api'

type StatusType = 'success' | 'error' | null

export const CertificatePage = () => {
  const classes = useStyles()
  const [value, setValue] = React.useState('')
  const [status, setStatus] = React.useState<StatusType>(null)
  const [certData, setCertData] = React.useState(null)
  const [loading, setLoading] = React.useState(false)

  const onChangeHandle = (e: any) => {
    const value = e.target.value.toUpperCase()
    setValue(value)
  }

  const onCheckHandle = async () => {
    if (value !== '') {
      setLoading(true)
      const firstCharIsNumberSymbol = value[0] === '№'
      let filteredValue = firstCharIsNumberSymbol ? value.slice(1) : value

      try {
        const result = await api.certificates.check(filteredValue);
        //@ts-ignore
        if (result.success) {
          //@ts-ignore
          setCertData(result.data);
          setStatus('success');
        }
      } catch (e) {
        setStatus('error');
      } finally {
        setLoading(false)
      }
    }
  }

  return (
    <>
      <MUIBlock lowPadding>
        <div className={classes.titleWrapper}>
          <div className={classes.cert}>
            <CertIcon />
          </div>
          <div className={classes.title}>
            <h3>{tl('Проверка подлинности сертификата обучения')}</h3>
            <span>{tl('Введите ниже номер сертификата, состоящий из цифр и/или букв')}</span>
          </div>
        </div>
      </MUIBlock>

      <MUIBlock
        controls={[
          [<div></div>],
          [<Button variant='contained' color='primary' onClick={onCheckHandle} disabled={loading}>{tl('Проверить')}</Button>],
        ]}
        controlsDivider
      >
        <FormSettingsRow label={'Введите номер сертификата:'} cssModifier='noMargin' className={`${classes.statusRow} ${status}`} >
          <div className={`${classes.input} ${status ? status : ''}`}>
            <TextField
              value={value}
              className={status === 'success' ? classes.valideInput : ''}
              onChange={onChangeHandle}
              variant="outlined"
              placeholder={tl('Можете вводить с тире или без тире')}
              error={status === 'error'}
              fullWidth
              autoFocus
              InputProps={{
                endAdornment: status === 'success' && (
                  <MUIAdornment>
                    <button>
                      <SvgIcon type="notification success" />
                    </button>
                  </MUIAdornment>
                ),
              }}
            />
            <div className={`${classes.status} ${status ? status : ''}`}>
              {status === 'success' ? 'Сертификат подлинный' : 'Сертификат с таким номером не найден'}
            </div>
          </div>
        </FormSettingsRow>
        {status === 'success' &&
          <div>
            <MUIBlockDivider />
            <FormSettingsRow label={'Имя и фамилия студента:'} cssModifier='noMargin' className={classes.semiBold}>
              {certData.student}
            </FormSettingsRow>
            <FormSettingsRow label={'Курс:'} cssModifier='noMargin' className={classes.semiBold}>
              <MUITooltip placement="top" title={certData?.course} dark >
                <div className={classes.courseName}>
                  {certData.course}
                </div>
              </MUITooltip>
            </FormSettingsRow>
            <FormSettingsRow label={'Дата начала обучения:'} cssModifier='noMargin' className={classes.semiBold}>
              {certData.start}
            </FormSettingsRow>
            <FormSettingsRow label={'Дата получения сертификата:'} cssModifier='noMargin' className={classes.semiBold}>
              {certData.end}
            </FormSettingsRow>
          </div>
        }
      </MUIBlock>
    </>
  )
}